module.exports = __webpack_public_path__ + "79e2ecbe781b92a39da32f49cde26fe1.svg";